import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// List of public routes that are safe for tracking (no PHI)
const safeRoutes = ['/', '/signin', '/register', '/resetpassword', '/terms', '/privacy', '/cookies', '/data-protection', '/ai-ethics'];

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

// Create helper functions to track conversions that can be called from other components
export const gtag_report_conversion = (url?: string) => {
  if (!window.gtag) {
    console.warn('Google tag not loaded, cannot track conversion');
    if (url) window.location.href = url;
    return false;
  }
  
  const callback = () => {
    if (typeof(url) != 'undefined') {
      window.location.href = url;
    }
  };
  
  console.log('Tracking conversion with gtag_report_conversion');
  window.gtag('event', 'conversion', {
    'send_to': 'AW-1066928765/jENhCO6EqMEaEP2U4PwD',
    'event_callback': callback
  });
  
  return false;
};

// Legacy function to maintain compatibility with existing code
export const trackConversion = (label?: string, url?: string) => {
  console.log('Using trackConversion with label:', label || 'default');
  return gtag_report_conversion(url);
};

export const GoogleTagManager = (): null => {
  const location = useLocation();
  
  useEffect(() => {
    // Only load Google Tag Manager on safe routes
    const currentPath = location.pathname;
    const isSafeRoute = safeRoutes.includes(currentPath) || 
                        currentPath.startsWith('/setpassword/');
    
    if (isSafeRoute) {
      // Initialize dataLayer if it doesn't exist
      window.dataLayer = window.dataLayer || [];
      
      // Create gtag function
      function gtag(...args: any[]) {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      
      // Only inject the script if it doesn't already exist
      if (!document.getElementById('google-tag-manager')) {
        // Create and inject the Google Tag Manager script
        const script = document.createElement('script');
        script.id = 'google-tag-manager';
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=AW-1066928765`;
        document.head.appendChild(script);
        
        // Initialize gtag
        gtag('js', new Date());
        gtag('config', 'AW-1066928765');
        
        console.log('Google Tag Manager initialized on route:', currentPath);
      }
      
      // Note: We no longer automatically track on specific routes
      // Instead, we'll use the trackConversion function at specific user actions
      
    } else {
      // Remove Google Tag Manager if user navigates to a protected route
      const script = document.getElementById('google-tag-manager');
      if (script) {
        document.head.removeChild(script);
        console.log('Google Tag Manager removed on protected route:', currentPath);
      }
      
      // Clear dataLayer
      if (window.dataLayer) {
        window.dataLayer = [];
      }
    }
  }, [location.pathname]);
  
  return null;
};